var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPlayCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-solid/play-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16663 8C2.16663 4.41015 5.07678 1.5 8.66663 1.5C12.2565 1.5 15.1666 4.41015 15.1666 8C15.1666 11.5899 12.2565 14.5 8.66663 14.5C5.07678 14.5 2.16663 11.5899 2.16663 8ZM11.5161 7.34441C12.0304 7.63016 12.0304 8.36989 11.5161 8.65565L7.78086 10.7308C7.28096 11.0085 6.66663 10.647 6.66663 10.0752V5.92491C6.66663 5.35304 7.28096 4.99157 7.78086 5.26929L11.5161 7.34441Z",
    fill: "#BFBFBF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlayCircle);
export default __webpack_public_path__ + "static/media/ic_play_circle.6cca98b628e87089a73a4e92402f52a9.svg";
export { ForwardRef as ReactComponent };